import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from "@angular/core";
import { OfferType } from "../../../../models/offer.model";
import { DisplayAllOffersData } from "../../../../models/display-all-offers-data.model";
import { LargeLoanProgramBankIntegrationNotice } from "../../../../models/large-loan-program.model";
import { getFirstOfferTabBundle } from "../../../../models/offer-bundle-grouping";
import { OfferSummaryWidgetData } from "./models/offer-summary-widget-data.model";
import { OfferSummaryWidgetFacade } from "./offer-summary-widget.facade";
import { ApplicationOfferBundleData } from "../../../../../application/application.model";

@Component({
    selector: "ifc-offer-summary-widget",
    templateUrl: "./offer-summary-widget.component.html",
    styleUrls: ["./offer-summary-widget.component.scss"],
    providers: [OfferSummaryWidgetFacade],
    standalone: false
})
export class OfferSummaryWidgetComponent implements OnInit {
  @Input() applicationId: number;
  @Input() offerBundle: ApplicationOfferBundleData;
  // Every offer on the page: SEE ALL OFFERS opens the product's first tab, not always this card's offer.
  @Input() offerBundles: ApplicationOfferBundleData[];
  @Input() largeLoanProgramOffered: boolean;

  @Output()
  displayAllOffers: EventEmitter<DisplayAllOffersData> = new EventEmitter();

  offerType = OfferType;
  data: OfferSummaryWidgetData;
  firstOfferTabBundleId: number;
  readonly bankIntegrationNotice = LargeLoanProgramBankIntegrationNotice;

  constructor(private facade: OfferSummaryWidgetFacade) {}

  ngOnInit(): void {
    this.data = this.facade.initData(this.offerBundle, this.largeLoanProgramOffered);
    this.firstOfferTabBundleId = getFirstOfferTabBundle(this.offerBundles, this.offerBundle).id;
  }

  onClickDisplayAllOffers(offerType: OfferType): void {
    const data: DisplayAllOffersData = {
      applicationId: this.applicationId,
      offerBundleId: this.firstOfferTabBundleId,
      offerType,
    };

    this.displayAllOffers.emit(data);
  }
}
